import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./polyfills";
import "core-js/stable";
import "regenerator-runtime/runtime";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfigProvider } from "./util/ConfigContext";
import { ThemeProvider } from "./util/ThemeContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrowserRouter as Router } from "react-router-dom";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
// document.documentElement.classList.add("dark");

root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <Router>
      <ErrorBoundary>
        <ConfigProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </ConfigProvider>
      </ErrorBoundary>
    </Router>
  </QueryClientProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//utsav-START
// serviceWorkerRegistration.register();
// Add an indicator for offline status
if ("serviceWorker" in navigator) {
  function updateOnlineStatus() {
    const condition = navigator.onLine ? "online" : "offline";

    // Optional: Add visual indicators for online/offline status
    if (condition === "offline") {
      // Create or show offline message
      let offlineMessage = document.getElementById("offline-message");
      if (!offlineMessage) {
        offlineMessage = document.createElement("div");
        offlineMessage.id = "offline-message";
        offlineMessage.textContent =
          "You are currently offline. Some content may be unavailable.";
        offlineMessage.style.cssText =
          "position: fixed; bottom: 0; left: 0; right: 0; background: #f44336; color: white; text-align: center; padding: 10px; z-index: 9999;";
        document.body.appendChild(offlineMessage);
      }
    } else {
      // Remove offline message
      const offlineMessage = document.getElementById("offline-message");
      if (offlineMessage) {
        offlineMessage.remove();
      }
    }
  }

  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);

  // Check initial status
  updateOnlineStatus();
}
//utsav-END
